const form = {

	ui: {},

	init: function() {
		this.bindUI();
		this.bindEvents();

		this.trigger_toggleHasValueClass();
	},
	
	trigger_toggleHasValueClass: function() {
		this.ui.$inputs.each((i, e) => {
			this.toggleHasValueClass(e);
		});
	},

	bindUI: function() {
		this.ui.$document = $(document);

		this.ui.$inputs = $(".js-form-input");
	},

	bindEvents: function() {
		this.ui.$document.on('focusout', '.js-form-input', this.toggleHasValueClass.bind(this));

		this.ui.$document.on('gform_post_render', function(event, form_id, current_page){
			$(".js-form-input").trigger('focusout');
		});
	},

    toggleHasValueClass: function(e) {
		let $this = $(e.currentTarget);

        if($this.val() && $this.val().length > 0){
            $this.addClass("has-value");
        } else {
            $this.removeClass("has-value");
        }
    }

};

export default form;
